import {
  Component,
  Input,
  OnInit,
  ElementRef,
  ChangeDetectorRef,
  HostListener,
  ViewChild,
} from '@angular/core';
import { UserAgentService } from '../../services/user-agent.service';
import Swiper from 'swiper';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-success-stories-cubes',
  templateUrl: './success-stories-cubes.component.html',
  styleUrls: [
    './success-stories-cubes.component.scss',
    './success-stories-cubes.component.en.scss',
  ],
})
export class SuccessStoriesCubesComponent implements OnInit {
  @Input({ required: true }) blockData!: any;

  searchText: string = '';
  blockViewDisplayCount: number = 8;
  chunkSize: number = 4;
  showAll: boolean = false;
  allResults: number = 0;
  currentSlideIndex: number = 0; // Track the current slide index

  currentSlider: Swiper | null = null;
  searchCubesList: any[] = []; // Moved out of getter
  chunkedCubes: any[][] = []; // Moved out of getter

  slideStep: number = 1; // How many items to slide on click
  currentIndex: number = 0; // The current position in the slider
  sliderTransform: string = 'translate3d(0, 0, 0)'; // The CSS transform for the sliding
  transitionDuration: string = '0.5s'; // Duration of the transition

  maxIndex: number = 0;

  @ViewChild('swiper') swiperComponent?: any;

  @Input() direction: 'ltr' | 'rtl' = 'rtl'; // Detect the direction

  breakpoints = {
    1024: {
      slidesPerView: 4,
      spaceBetween: 14,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 14,
    },
    320: {
      slidesPerView: 1,
      spaceBetween: 14,
    },
  };

  isMobile: boolean = false;

  constructor(
    private el: ElementRef,
    private userAgentService: UserAgentService,
    private cdr: ChangeDetectorRef, // Inject ChangeDetectorRef
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.isMobile = this.userAgentService.isMobileDevice();
  }

  ngOnInit(): void {
    this.detectLanguageDirection();
    this.updateSearchCubesList(); // Initialize the list on component load
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    let width = (event.target as Window).innerWidth;
    this.isMobile = width <= 1300;
  }

  // Method to detect language and set direction
  detectLanguageDirection(): void {
    const currentUrl = this.router.url;
    if (currentUrl.includes('/en/')) {
      this.direction = 'ltr'; // Set direction to LTR for English
    } else {
      this.direction = 'rtl'; // Default to RTL for Hebrew
    }
  }
  // Method to update searchCubesList based on searchText and other conditions
  updateSearchCubesList(): void {
    let filteredList = this.blockData.cubesList.map(
      (cube: any, index: number) => {
        return { ...cube, id: index }; // Spread the existing properties and add id
      }
    );

    if (this.searchText) {
      filteredList = filteredList.filter((cube: any) =>
        cube.title.toLowerCase().includes(this.searchText.toLowerCase())
      );
    }

    this.allResults = filteredList.length;

    // Handle non-slider view
    if (!this.blockData.useSliderView && !this.showAll) {
      filteredList = filteredList.slice(0, this.blockViewDisplayCount);
    }
    //Handle slider view
    if (this.blockData.useSliderView) {
      this.maxIndex = filteredList.length - this.chunkSize;
      this.updateSlide();
    }

    this.searchCubesList = filteredList;
    this.chunkCubes(); // Update the chunked list
 
    if (this.blockData.useSliderView && this.userAgentService.isMobileDevice()) {  
      setTimeout(() => {
        this.swiperComponent.nativeElement.swiper.update();
        this.swiperComponent.nativeElement.swiper.slideTo(0);
      }, 50);
    }
  }

  // Method to chunk the cubes based on chunkSize
  chunkCubes(): void {
    const chunks = [];
    for (let i = 0; i < this.searchCubesList.length; i += this.chunkSize) {
      chunks.push(this.searchCubesList.slice(i, i + this.chunkSize));
    }
    this.chunkedCubes = chunks;
  }

  searchClear(): void {
    this.searchText = '';
    this.updateSearchCubesList();
  }

  // Method to get the processed cube image URL
  getProcessedCubeImageUrl(url: string): string {
    return url ? `${url}?width=350&mode=pad&format=webp` : '';
  }

  includeItemClick(cube: any): void {
    if (!this.checkIfShowIncludeItem(cube)) return;

    const item = cube.id;
    const slide = this.getSectionElem(
      `#swiper-slide-${item} .include-item__drop`
    );
    if (!slide) return;

    const newHeight = slide.scrollHeight + 10;

    if (!this.isMobile) {
      const slideElement = this.getSectionElem(
        `#swiper-slide-${item}`
      ) as HTMLElement | null;
      if (!slideElement || !slideElement.parentElement) return;

      const parentElement = slideElement.parentElement as HTMLElement;
      if (slide.classList.contains('show')) {
        // const existHeight = parentElement.style.marginBottom;
        // const marginHeight = existHeight ? parseInt(existHeight) : newHeight;
        // parentElement.style.marginBottom = `${marginHeight}px`;
        slide.removeAttribute('style');
      } else {
        /*// Get the closest `slider-row-chunk` and check if any other items are open
        const sliderChunk = slide.closest('.slider-row-chunk');
        if (sliderChunk) {
          const hasOpenItems =
            sliderChunk.querySelectorAll('.include-item__drop.show').length > 0;

          // If no open items, remove the style from the parent to collapse
          if (!hasOpenItems) {
            parentElement.removeAttribute('style');
          }
        }*/
        //slide.style.marginBottom = `${newHeight}px`;
        slide.style.display = 'block';
      }
    } else {
      //Mobile mode
      if (slide.classList.contains('show')) {
        //slide.style.marginBottom = `${newHeight}px`;
        slide.removeAttribute('style');
      } else {
        slide.style.display = 'block';
      }
    }
  }

  checkIfShowIncludeItem(cube: any): boolean {
    return cube.description || cube.linkUrl;
  }

  showAllBtnClick(): void {
    this.showAll = true;
    this.updateSearchCubesList(); // Recalculate cubes after showing all
  }

  getSectionElem(field: String): HTMLElement {
    return this.el.nativeElement.querySelector(field);
  }

  getSectionElemAll(field: String): HTMLElement[] {
    return this.el.nativeElement.querySelectorAll(field);
  }

  // Function to handle sliding left (next) for RTL and LTR
  nextSlide(): void {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex += this.slideStep;
      this.updateSlide();
    }
  }

  // Function to handle sliding right (previous) for RTL and LTR
  prevSlide(): void {
    if (this.currentIndex > 0) {
      this.currentIndex -= this.slideStep;
      this.updateSlide();
    }
  }

  // Update the slider's transform property to move the slides
  updateSlide(): void {
    const slideWidth = 23.5; // The width percentage of each slide, including margin
    let translateValue;

    // Handle RTL vs LTR translation logic
    if (this.direction === 'rtl') {
      translateValue = this.currentIndex * (slideWidth + 1); // Moving right
    } else {
      translateValue = -(this.currentIndex * (slideWidth + 1)); // Moving left
    }

    // Update the transform CSS for sliding
    this.sliderTransform = `translate3d(${translateValue}%, 0, 0)`;
    this.cdr.detectChanges(); // Update the view
  }

  // Check if we're at the first or last possible slide position
  isAtFirstSlide(): boolean {
    return this.currentIndex === 0;
  }

  isAtLastSlide(): boolean {
    return this.currentIndex >= this.maxIndex;
  }

  // Generate bullets for the pagination on mobile
  getPaginationBullets(): any[] {
    return Array.from({
      length: Math.ceil(this.searchCubesList.length / this.chunkSize),
    });
  }

  // Navigate to a specific slide index when a bullet is clicked
  goToSlide(index: number): void {
    this.currentIndex = index;
    this.updateSlide();
  }
}
